export default __webpack_public_path__ + "static/3-20a6410aec1f731cda0e214033d485b8.webp";